import React from 'react';
import { useLoadedEvents } from '../../../../data/hooks/events/useLoadedEvents/useLoadedEvents';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import EventsList from './EventsList';
import './ListingStatusPerEvent.scss';

const ListingStatusPerEvent = (props) => {
    const all = useLoadedEvents(),
        communities = all.filter((event) => event._isCommunity),
        events = all.filter((event) => !event._isCommunity),
        i18n = useI18n();

    return (
        <div className="ListingStatusPerEvent">
            <p>
                <b>{i18n['label.change-visibility']}</b>
            </p>
            {communities.length ? (
                <>
                    <h2>{i18n['label.community-participants']}</h2>
                    <EventsList events={communities} {...props} />
                </>
            ) : null}
            {events.length ? (
                <>
                    <h2>{i18n['label.event']}</h2>
                    <EventsList events={events} {...props} />
                </>
            ) : null}
        </div>
    );
};

export default ListingStatusPerEvent;
